module.exports = __webpack_public_path__ + "img/exam-start.f0c5f0cc.png";